export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    displayOrder: {
        label: "Display order"
    },
    divisionId: {
        label: "Division"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    displayOrder: {
        label: "Ordre d'affichage"
    },
    divisionId: {
        label: "Service"
    }
};